import React, { LabelHTMLAttributes, PropsWithChildren } from 'react';

type LabelProps = PropsWithChildren<LabelHTMLAttributes<HTMLLabelElement>>;

export function Label(props: LabelProps) {
  return <label {...props} className="text-color-gray-darker text-uppercase text-weight-bold block text-size-small" />;
}
